import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';

export const DocViewerContextPanelAnimations = [
	trigger(
		'slideInOutAnimation',
		[
			state('collapsed', style({ width: '55px' })),
			state('expanded', style({ width: '{{ maxWidth }}' }), { params: { maxWidth: '310px' } }),
			transition(
				'collapsed => expanded',
				[
					group([
						query('@rotateAnimation', animateChild()),
						animate('500ms ease-in-out')
					]),
					query('@fadeInOutAnimation', animateChild())
				]
			),
			transition(
				'expanded => collapsed',
				[
					group([
						query('@rotateAnimation', animateChild()),
						animate('500ms ease-in-out')
					]),
					query('@fadeInOutAnimation', animateChild())
				]
			)
		]
	),
	trigger(
		'fadeInOutAnimation',
		[
			state('expanded', style({ visibility: 'visible' })),
			state('collapsed', style({ visibility: 'hidden' })),
			transition(
				'* => expanded',
				[
					animate('50ms')
				]
			)
		]
	),
	trigger(
		'shrinkAnimation',
		[
			state('visible', style({ height: 'calc(100% - 270px)' })),
			state('hidden', style({ height: 'calc(100% - 113px)' })),
			transition(
				'* => *',
				[
					animate('1s .5s ease-in-out')
				]
			)
		]
	),
	trigger(
		'inOutAnimation',
		[
			transition(
				':enter',
				[
					style({ marginTop: '-157px' }),
					group([
						animate('1s .5s ease-in-out',
							style({ marginTop: 0 }))
					])
				]
			),
			transition(
				':leave',
				[
					style({ marginTop: 0 }),
					animate('1s .5s ease-in-out',
						style({ marginTop: '-157px' }))
				]
			)
		]
	),
	trigger(
		'rotateAnimation',
		[
			transition(
				'* => expanded',
				[
					style({ transform: 'rotate(180deg)' }),
					animate('500ms ease-in-out',
						style({ transform: '*' }))
				]
			),
			transition(
				'* => collapsed',
				[
					style({ transform: '*' }),
					animate('500ms ease-in-out',
						style({ transform: 'rotate(180deg)' }))
				]
			),
			state('collapsed', style({ transform: 'rotate(180deg)' })),
			state('expanded', style({ transform: '*' }))
		]
	)
];
